import { IconButton } from '@mui/material';

type DialButtonProps = {
  value: string;
  disabled?: boolean;
  onClick: (value: string) => void;
};

const DialButton = ({ value, onClick, disabled }: DialButtonProps) => {
  return (
    <IconButton
      sx={{ margin: 'auto' }}
      onClick={() => onClick(value)}
      variant="outlined"
      size="extra-large"
      color="primary"
      data-dd-privacy="hidden"
      data-dd-action-name="hidden"
      disabled={disabled}
    >
      {value}
    </IconButton>
  );
};

export default DialButton;
